import { createFileRoute } from "@tanstack/react-router"
import { ReportsLanding } from "@/features/reports/components/ReportsLanding"

export const Route = createFileRoute("/(authenticated)/reports/")({
  component: ReportsLandingPage,
})

function ReportsLandingPage() {
  return <ReportsLanding />
}
